<template>
    <div class="slim">
        <h3 class="block-title text-center" v-if="content?.meta?.title"><span class="block-title-content theme-tinted-border">{{this.content.meta.title}}</span></h3>
        <div class="row album-row">
            <div v-for="(album, index) in this.albums" :key="album.meta.id" class="col-12 col-sm-4 col-xs-3 d-flex">
                <div class="album-item" v-if="expanded || index < 3">
                    <div class="album-cover-image" :style="{
                        background: album._frontend.cover_content_unit ? 'url(' + context.storageEndpoint + (album._frontend.cover_content_unit.file_name || album._frontend.cover_content_unit.thumbnail_file_name) + ') 0% 0% / cover' : '',
                        backgroundPosition: 'center'
                    }">
                        <div class="album-hover-layout">
                            <button class="btn btn-sm"
                                @click="openAlbum(album.meta.id, null, album)">{{$t('message.open_album')}}</button>
                        </div>
                    </div>
                    <div class="album-subtitle">{{album.content_units.length}} {{$t('message.photos')}}</div>
                    <h5 class="album-title">{{album.meta.title}}</h5>
                </div>

                <div class="backdrop" v-if="isCurrentAlbum(album.meta.id)"></div>
                <display-album
                    v-if="isCurrentAlbum(album.meta.id)"
                    ref="album"
                    :context="context"
                    :providerInformationBlockId="block.id"
                    :editing="false"
                    :close="closeAlbum"
                    :album="album">
                </display-album>
            </div>
            <div v-if="albums.length > 3" class="col-12 text-center button-bar">
                <button
                    v-if="!this.expanded"
                    class="btn btn-secondary-outline"
                    @click="toggleExpand(true)"
                >{{$t('message.more_albums')}}</button>
                <button
                    v-if="this.expanded"
                    class="btn btn-secondary-outline"
                    @click="toggleExpand(false)"
                >{{$t('message.collapse_albums')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventViewPortfolioAlbum } from '../../bu/models/GA4';
    export default {
        props: ['block', 'providerId', 'context'],

        data() {
            var content = JSON.parse(this.block.content);
            if (!content.albums) {
                content.albums = [];
            }

            for (var i in content.albums) {
                this.$set(content.albums[i], '_frontend', {
                    cover_content_unit: null,
                });

                content.albums[i].content_units = content.albums[i].content_units.filter(contentUnit => !!contentUnit);
                for(var k in content.albums[i].content_units) {
                    if (content.albums[i].content_units[k].id === content.albums[i].meta.cover_content_unit_id) {
                        content.albums[i]._frontend.cover_content_unit = content.albums[i].content_units[k];
                    }
                }
            }

            return {
                content: content,
                informationBlock: this.block.information_block,
                albums: content.albums,
                openedAlbumId: null,
                expanded: false
            };
        },

        methods: {
            openAlbum(albumId, contentUnitId = null, album) {
                this.openedAlbumId = albumId;
                if (contentUnitId) {
                    this.$nextTick(() => {
                        if (this.$refs['album'].length > 0) {
                            this.$refs['album'][0].openContentUnitId(contentUnitId);
                        }
                    });
                }
                this.trackViewPortfolioAlbum(album);
            },

            closeAlbum(albumId) {
                this.openedAlbumId = null;
            },

            isCurrentAlbum(albumId) {
                return this.openedAlbumId === albumId;
            },

            toggleExpand(expanded) {
                this.expanded = expanded;
                this.$forceUpdate();
            },

            trackViewPortfolioAlbum(album) {
                window.tracker.track(() => new EventViewPortfolioAlbum(album));
            }
        }
    }
</script>

<style scoped>
    .box-typical {
        margin-top: 1em;
        margin-bottom: 1em;
    }

    .album-row {
        margin: 0 16px;
        justify-content: center;
    }

    .album-item {
        flex-grow:1;
    }

    .landing-block:nth-child(odd) .album-item {
        background: #F6F8FA;
    }

    .album-item {
        background: white;
        border-radius: 5px;
        overflow: hidden;
        margin-top: 1em;
        margin-bottom: 1em;
    }

    .album-cover-image {
        background: #E0E0E0;
        width: 100%;
        padding-bottom: 75%;
        position: relative;
    }

    .album-title {
        margin: 16px 0 18px;
        padding: 0px 24px;
        font-size: 16px;
        color: black;
    }

    .album-subtitle {
        margin: 26px 0 8px 24px;
        font-size: 14px;
        color: #9B9DA0;
    }

    .album-hover-layout {
        position: absolute;
        top:0;
        right:0;
        left:0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.4);
        opacity: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .album-hover-layout:hover {
        opacity: 1;
        background-color: rgba(1, 0, 0, 0.4);
    }

    .album-hover-layout .btn {
        border: none;
        background-color: transparent;
        color: white;
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        text-align: center;
        width: 100%;
    }

    .backdrop {
        background: #000000BB;
        z-index: 81;
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .button-bar {
        margin-top: 40px;
        margin-bottom: 29px;
    }
</style>
